import {Breadcrumbs, ErrorPopup, Notice, Title} from '@management-ui/core';
import {reverse} from 'named-urls';
import React from 'react';
import routes from '../../../../routes';

const Wrapper = ({title, loading, titleControls, referrer, crumbs, errors, children}) => {
  return (
    <>
      <Breadcrumbs crumbs={crumbs}/>
      <Title title={title} loading={loading} controls={titleControls}/>
      <Notice
        display={referrer && referrer.archived}
        message={[
          'This referrer has been archived and is therefore no longer available.',
          'You won\'t be able to modify them unless they are restored.'
        ].join(' ')}
      />
      {children}
      <ErrorPopup errors={['referrer']} messages={errors}/>
    </>
  );
}

Wrapper.standardCrumbs = [
  {title: 'Orders', link: reverse(routes.orders.index)},
  {title: 'Referrers', link: reverse(routes.referrers.index)}
];
Wrapper.archiveCrumbs = [
  {title: 'Archive', link: reverse(routes.archive.index)},
  {title: 'Referrers', link: reverse(routes.archive.index, {tab: 'referrers'})}
];

export default Wrapper;
